import { Component, EventEmitter, Output } from '@angular/core';
import { CommonConfirmationModalData } from
  'src/app/components/common/common-confirmation-modal/common-confirmation-modal.component.model';
import { SecurityService, WorkflowContextService } from 'src/app/services';

@Component({
  selector: 'wm-add-role-janus',
  standalone: false,
  templateUrl: './add-role-janus.component.html',
  styleUrls: ['./add-role-janus.component.scss']
})
export class AddRoleJanusComponent {
  roleName = '';

  colorOptions = [
    { name: 'Green', value: 'green' },
    { name: 'Yellow', value: 'yellow' },
    { name: 'Orange', value: 'orange' },
    { name: 'Red', value: 'red' },
    { name: 'Purple', value: 'purple' },
    { name: 'Light Blue', value: 'light-blue' },
    { name: 'Light Green', value: 'light-green' },
    { name: 'Light Yellow', value: 'light-yellow' }
  ];

  selectedColor: string | null = null;
  @Output() roleCreated = new EventEmitter<void>();


  @Output() closeCard = new EventEmitter<void>();

  confirmModal: CommonConfirmationModalData = {
    open: false,
    modalDescp: '',
    modalSubDescp: '',
    yesNoBtn: false,
    okBtn: false,
    closeBtn: false,
    status: 'default'
  };

  constructor(
    private securitySvc: SecurityService,
    private context: WorkflowContextService
  ) { }

  close(): void {
    this.closeCard.emit();
  }

  save(): void {
    if (!this.roleName.trim()) {
      this.openOkModal(
        'Role name is required',
        'Please enter a valid role name.'
      );
      return;
    }

    this.securitySvc
      .isRoleNameAvailable(
        this.context.client ? this.context.client.id : null,
        this.roleName,
        null
      )
      .subscribe(isTaken => {
        if (isTaken) {
          this.openOkModal(
            'Duplicate Role',
            'A role with this name already exists.'
          );
          return;
        }

        this.confirmModal = {
          open: true,
          modalDescp: 'Create Role',
          modalSubDescp: `Are you sure you want to create the role "${this.roleName}"?`,
          yesNoBtn: true,
          okBtn: false,
          closeBtn: false,
          status: 'default'
        };
      });
  }

  onConfirmYes(): void {
    const role = {
      name: this.roleName,
      color: this.selectedColor,
      client: this.context.client
    };

    this.securitySvc.saveRole(role).subscribe({
      next: () => {
        this.confirmModal = {
          open: true,
          modalDescp: 'Success',
          modalSubDescp: 'Role created successfully.',
          yesNoBtn: false,
          okBtn: true,
          closeBtn: false,
          status: 'success'
        };

        // ✅ notify parent
        this.roleCreated.emit();
      },
      error: () => {
        this.openOkModal(
          'Error',
          'Failed to create role. Please try again.'
        );
      }
    });
  }


  onConfirmNo(): void {
    this.confirmModal.open = false;
  }

  onConfirmOk(): void {
    this.confirmModal.open = false;
    this.close();
  }

  private openOkModal(title: string, message: string): void {
    this.confirmModal = {
      open: true,
      modalDescp: title,
      modalSubDescp: message,
      yesNoBtn: false,
      okBtn: true,
      closeBtn: false,
      status: 'default'
    };
  }
}
